import {
  Avatar,
  Box,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "@mui/material";
import { IAccount } from "../../../store/interfaces/IAccount";
import { Plus } from "lucide-react";
import { useState } from "react";
import { AccountForm } from "../create";

interface AccountTableListProps {
  accounts: IAccount[];
}

export const AccountTableList: React.FC<AccountTableListProps> = ({ accounts }) => {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 4, maxHeight: '70vh', overflow: 'auto' }}>
        <Box sx={{ padding: 2, display: "flex", justifyContent: "end" }}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<Plus />}
            onClick={() => setOpenDialog(true)}
          >
            Crear Nueva Cuenta
          </Button>
        </Box>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Logo</strong></TableCell>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell><strong>Social Media</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {accounts.map((account) => (
              <TableRow key={account.id}>
                <TableCell sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    src={account.logo}
                    alt={account.name}
                    sx={{ bgcolor: account.primaryColor }}
                  />
                  {account.owner && (
                    <Chip label="Owner" color="secondary" size="small" sx={{ color: '#fff' }} />
                  )}
                  {account.id && (
                    <Chip label={account.id} color="primary" size="small" sx={{ color: '#fff' }} />
                  )}
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    href={account.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: account.primaryColor,
                      fontWeight: 'bold',
                      textTransform: 'none',
                    }}
                  >
                    <Typography fontWeight="bold">{account.name}</Typography>
                  </Button>
                </TableCell>
                <TableCell>{account.email ?? '—'}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    {account.socialMediaList.map((sm) => (
                      <Chip
                        key={sm.name}
                        label={`@${sm.username}`}
                        size="small"
                        sx={{ fontWeight: 'bold' }}
                      />
                    ))}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog with AccountForm */}
      <AccountForm open={openDialog} setOpenDialog={setOpenDialog} />
    </>
  );
};
